import React, {useState} from 'react';
import {Box, Typography} from '@mui/material';
import {useTranslation} from "react-i18next";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export default function Faq(): JSX.Element {

  const {t} = useTranslation();

  const [faq1, setFaq1] = useState<boolean>(true);
  const [faq2, setFaq2] = useState<boolean>(false);
  const [faq3, setFaq3] = useState<boolean>(false);
  const [faq4, setFaq4] = useState<boolean>(false);

  return (
    <Box sx={{width: "100%", maxHeight: "fit-content", overflow: "hidden"}}>
      <Box sx={{p: "30px 0px"}}>
        <Box onClick={(): void => setFaq1(!faq1)} sx={{display: "flex", justifyContent: "space-between", alignItems: "center", position: "relative", pb: 3, cursor: "pointer"}}>
          <Typography variant="h4" color="ornament.light" sx={{fontWeight: "700", fontSize: "20px", pr: 2}}>
            {t("landing_page.faq.question_1")}
          </Typography>
          <KeyboardArrowDownIcon sx={{color: "#50DBB9", fontSize: "32px", transform: faq1 ? "rotate(180deg)" : "none", transition: "all 0.2s ease"}} />
        </Box>
        <Box sx={{maxHeight: "fit-content", overflow: "hidden"}}>
          <Typography variant="body1" color="ornament.light" sx={{fontWeight: "300", fontSize: "18px", mt: faq1 ? "0px" : "-300%", transition: "all 0.2s ease-in-out"}}>
            {t("landing_page.faq.answer_1")}
          </Typography>
        </Box>
      </Box>
      <Box sx={{borderTop: "1px solid white", p: "30px 0px"}}>
        <Box onClick={(): void => setFaq2(!faq2)} sx={{display: "flex", justifyContent: "space-between", alignItems: "center", position: "relative", pb: 3, cursor: "pointer"}}>
          <Typography variant="h4" color="ornament.light" sx={{fontWeight: "700", fontSize: "20px", pr: 2}}>
            {t("landing_page.faq.question_2")}
          </Typography>
          <KeyboardArrowDownIcon sx={{color: "#50DBB9", fontSize: "32px", transform: faq2 ? "rotate(180deg)" : "none", transition: "all 0.2s ease"}} />
        </Box>
        <Box sx={{maxHeight: "fit-content", overflow: "hidden"}}>
          <Typography variant="body1" color="ornament.light" sx={{fontWeight: "300", fontSize: "18px", mt: faq2 ? "0px" : "-300%", transition: "all 0.2s ease-in-out"}}>
            {t("landing_page.faq.answer_2")}
          </Typography>
        </Box>
      </Box>
      <Box sx={{borderTop: "1px solid white", p: "30px 0px"}}>
        <Box onClick={(): void => setFaq3(!faq3)} sx={{display: "flex", justifyContent: "space-between", alignItems: "center", position: "relative", pb: 3, cursor: "pointer"}}>
          <Typography variant="h4" color="ornament.light" sx={{fontWeight: "700", fontSize: "20px", pr: 2}}>
            {t("landing_page.faq.question_3")}
          </Typography>
          <KeyboardArrowDownIcon sx={{color: "#50DBB9", fontSize: "32px", transform: faq3 ? "rotate(180deg)" : "none", transition: "all 0.2s ease"}} />
        </Box>
        <Box sx={{maxHeight: "fit-content", overflow: "hidden"}}>
          <Typography variant="body1" color="ornament.light" sx={{fontWeight: "300", fontSize: "18px", mt: faq3 ? "0px" : "-300%", transition: "all 0.2s ease-in-out"}}>
            {t("landing_page.faq.answer_3")}
          </Typography>
        </Box>
      </Box>
      <Box sx={{borderTop: "1px solid white", p: "30px 0px"}}>
        <Box onClick={(): void => setFaq4(!faq4)} sx={{display: "flex", justifyContent: "space-between", alignItems: "center", position: "relative", pb: 3, cursor: "pointer"}}>
          <Typography variant="h4" color="ornament.light" sx={{fontWeight: "700", fontSize: "20px", pr: 2}}>
            {t("landing_page.faq.question_4")}
          </Typography>
          <KeyboardArrowDownIcon sx={{color: "#50DBB9", fontSize: "32px", transform: faq4 ? "rotate(180deg)" : "none", transition: "all 0.2s ease"}} />
        </Box>
        <Box sx={{maxHeight: "fit-content", overflow: "hidden"}}>
          <Typography variant="body1" color="ornament.light" sx={{fontWeight: "300", fontSize: "18px", mt: faq4 ? "0px" : "-300%", transition: "all 0.2s ease-in-out"}}>
            {t("landing_page.faq.answer_4")}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}